import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getLanguages() {
    return axios.get(ENV.systemBase + "/languages/list", this.requestConfig());
  }

  static updateLocation(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/locations/update", requestData, this.requestConfig());
  }

  static uploadLogo(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/dealers/logo/upload", requestData, this.requestConfig());
  }
}

export default Service;
